var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-flex":"100"}},[_c('md-card',[_c('h3',[_vm._v(_vm._s(_vm.topic)+" Badges")]),_vm._v(" "),_vm._l((_vm.availableBadges),function(badge){return _c('md-layout',{key:badge.key,staticClass:"badgeGutter",attrs:{"md-flex":"33","md-gutter":""}},[_c('user-badge',{attrs:{"badge":badge}})],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e0adf9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/CollectedBadges.vue
// module id = 435
// module chunks = 0